import React from 'react'
import FormComponent from "../components/formComponent";
import { renderReport } from "../components/elementList";

let documentation = {
    title: 'Choose Field',
    brief: 'Choose a Field name.',
    content: "All Acuadori Fields EntityViews related to the chosen customer will be selected."
};

class UiGetFieldEntities extends React.Component {

    static defaultProps = {
        error: (error) => { },
        finished: (data, report) => { },
        fieldBaseName: "acuadori field",
        customerList: []
    };

    constructor(props) {
        super(props);

        this.customerService = props.services.customer;

        this.state = {
            customerFields: null,
            selectedField:{},
            finished: false
        }
    }

    getComponentData = () => {
        return this.state.selectedField;
    }

    componentDidMount() {
        const { customerList, fieldBaseName } = this.props;
        const fieldRequests = customerList.map((customer) => {
            const entityType = fieldBaseName + customer.type.fieldPost;
            return this.customerService.getCustomerFieldEntities(customer.id, entityType)
                .then((fields) => ({ ...customer, fields: fields || [] }));
        });

        Promise.all(fieldRequests)
            .then((customerFields) => this.setState({ customerFields: customerFields }))
            .catch(this.props.error);
    }
    
    documentation = () => { return documentation; }

    renderAlert = (message, variant) => {
        this.setState({ messageAlert: message, variantAlert: variant, showAlert: true });
    };

    reportAllComponentData = () => {
        let { selectedField } = this.state;
        let report= [{key: "Field", value: selectedField.name}];
        selectedField.entities.forEach((fieldEntity) => {
            let item = {
                key: fieldEntity.entity.name,
                value: fieldEntity.entity.type,
            };
            report.push(item);
        })
        return report;
    }

    handleSelectFieldNext = (response) => {
        let { customerFields } = this.state;

        let value = JSON.parse(response.field);

        let { fields } = value;
        let selectedField = {
            name: value.name,
            entities: []
        };

        for (let i = 0; i < fields.length; i++) {
            let { instanceId, fieldId } = fields[i];

            if (!customerFields[instanceId]) {
                this.props.error({ message: 'Inhexistent customer, please choose one!' });
                return false;
            }
            else {
                let { name, id, type } = customerFields[instanceId];
                selectedField.entities.push({
                    id: id,
                    name: name,
                    type: type,
                    entity: customerFields[instanceId].fields[fieldId]
                });
            }
        }

        this.setState(
            {
                finished: true,
                selectedField: selectedField
            },
            () => { this.props.finished(this.getComponentData(), this.reportAllComponentData()); }
        );
        return true;
    }



    renderGetField = () => {
        let { customerFields } = this.state;
        if ((!customerFields) || customerFields.length === 0) { 
            return null; 
        }

        let fields = {};
        for (let i = 0; i < customerFields.length; i++) {
            let item = customerFields[i];
            if((!item) || (!item.hasOwnProperty('fields')) ) {
                return null
            }
            for (let j = 0; j < item.fields.length; j++) {
                let name = item.fields[j].name.substr(item.type.fieldPre.length);
                if (!fields.hasOwnProperty(name)) {
                    fields[`${name}`] = [{ instanceId: i, fieldId: j }];
                }
                else {
                    fields[`${name}`].push({ instanceId: i, fieldId: j });
                }
            }
        }

        let elements = Object.keys(fields).map(fieldName => {
            let label = fieldName;
            let value = JSON.stringify({ name: fieldName, fields: fields[fieldName] });
            return { value: value, label: label }
        });

        if (elements.length === 0) {
            return <p className="text-warning">No Field Entity Views are assigned to the selected customer.</p>;
        }

        let formElement = [
            {
                key: 'field', type: 'select', inputType: 'select', placeholder: 'Select the device\'s field location',
                value: '', label: 'Field', options: elements
            },
        ];

        return (
            <div>
                <FormComponent
                    initialValues={{ field: '' }}
                    validateFunc={(values) => {
                        const errors = {};
                        if (!values.field) { errors.field = 'Required'; }
                        return errors;
                    }}
                    submitFunc={this.handleSelectFieldNext}
                    inputs={formElement}
                />
            </div>
        );
    }

    render() {
        let { finished } = this.state;


        return (
            <div className="container-fluid">
                <div className="m-4 p-4">
                    {!finished && this.renderGetField()}
                    {finished && renderReport(this.reportAllComponentData())}
                </div>
            </div>);
    }
}


export default UiGetFieldEntities;
export {
    UiGetFieldEntities,
    documentation
}